import { isFalsy } from "@vega-core/utils/isFalsy";

export type GroupedPermission = {
  subjectId: UserPermissionEntry["subjectId"];
  subjectType: UserPermissionEntry["subjectType"];
  subjectName: UserPermissionEntry["subjectName"];
  assetClass: UserPermissionEntry["assetClass"];
  permissions: UserPermissionEntry[];
  selectedRole: UserPermissionEntry["roleId"];
  manageable: UserPermissionEntry["manageable"];
};

export function groupPermissionsByRole(
  permissions: UserPermissionEntry[],
): Record<string, UserPermissionEntry[]> {
  return permissions.reduce(
    (acc, permission) => {
      const { roleId } = permission;

      if (isFalsy(roleId)) {
        return acc;
      }

      if (isFalsy(acc[roleId])) {
        acc[roleId] = [];
      }

      acc[roleId].push(permission);

      return acc;
    },
    {} as Record<string, UserPermissionEntry[]>,
  );
}

export function groupPermissionsBySubject(
  permissions: UserPermissionEntry[],
): GroupedPermission[] {
  const groupedPermissions = permissions.reduce(
    (acc, permission) => {
      const {
        subjectId,
        subjectType,
        subjectName,
        assetClass,
        roleId,
        manageable,
      } = permission;

      if (isFalsy(subjectId)) {
        return acc;
      }

      if (isFalsy(acc[subjectId])) {
        acc[subjectId] = {
          subjectId,
          subjectType,
          subjectName,
          manageable,
          assetClass,
          permissions: [],
          selectedRole: roleId, // Set the roleId for the group as we expect only one role per product
        };
      }

      acc[subjectId].permissions.push(permission);

      return acc;
    },
    {} as Record<string, ReturnType<typeof groupPermissionsBySubject>[0]>,
  );

  return Object.values(groupedPermissions);
}

import { type UserPermissionEntry } from "@vega-api/generated/types/userPermissionEntry";
